'use client';
import React from 'react';

const StatsSection = () => {
  // Stats data matching the reference image
  const statsData = [
    {
      number: '234',
      unit: 'M',
      description: 'Supporting multiple currencies for users.',
      isHighlighted: false
    },
    {
      number: '768',
      unit: 'K',
      description: 'Gaining new users every single month',
      isHighlighted: true
    },
    {
      number: '5.0',
      unit: '★',
      description: 'High star ratings from satisfied users.',
      isHighlighted: false
    },
    {
      number: '$8.8',
      unit: 'B',
      description: 'Generating increased revenue consistently',
      isHighlighted: false
    }
  ];

  return (
    <div data-component-id="src/components/sections/StatsSection.jsx:34:4" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="34" data-component-end-line="73" data-component-file="StatsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-global-17%20py-%5B80px%5D%20sm%3Apy-%5B90px%5D%20md%3Apy-%5B100px%5D%22%7D" className="w-full bg-global-17 py-[80px] sm:py-[90px] md:py-[100px]">
      <div data-component-id="src/components/sections/StatsSection.jsx:35:6" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="35" data-component-end-line="72" data-component-file="StatsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-id="src/components/sections/StatsSection.jsx:36:8" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="36" data-component-end-line="71" data-component-file="StatsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-%5B20px%5D%20sm%3Agap-%5B24px%5D%20md%3Agap-%5B28px%5D%20w-full%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[20px] sm:gap-[24px] md:gap-[28px] w-full">
          {statsData.map((stat, index) => (
            <div data-component-id="src/components/sections/StatsSection.jsx:38:12" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="38" data-component-end-line="69" data-component-file="StatsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" 
              key={index} 
              className={`flex flex-col gap-[16px] sm:gap-[18px] md:gap-[20px] justify-center items-center w-full rounded-[20px] sm:rounded-[22px] md:rounded-[24px] pt-[40px] sm:pt-[45px] md:pt-[50px] pr-[20px] sm:pr-[24px] md:pr-[28px] pb-[40px] sm:pb-[45px] md:pb-[50px] pl-[20px] sm:pl-[24px] md:pl-[28px] ${
                stat.isHighlighted 
                  ? 'bg-[#1d9b5d]' 
                  : 'bg-[#f5f7fa]'
              }`}
            >
              <div data-component-id="src/components/sections/StatsSection.jsx:46:14" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="46" data-component-end-line="63" data-component-file="StatsSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-%5B2px%5D%20sm%3Agap-%5B3px%5D%20md%3Agap-%5B4px%5D%20justify-center%20items-baseline%20w-auto%22%7D" className="flex gap-[2px] sm:gap-[3px] md:gap-[4px] justify-center items-baseline w-auto">
                <p data-component-id="src/components/sections/StatsSection.jsx:47:16" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="47" data-component-end-line="51" data-component-file="StatsSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D" className={`text-[48px] sm:text-[56px] md:text-[64px] font-urbanist font-bold leading-[1] text-center ${
                  stat.isHighlighted ? 'text-white' : 'text-[#1a1a1a]'
                } w-auto`}>
                  {stat.number}
                </p>
                {stat.unit === '★' ? (
                  <span data-component-id="src/components/sections/StatsSection.jsx:53:18" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="53" data-component-end-line="55" data-component-file="StatsSection.jsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%98%85%22%7D" className={`text-[32px] sm:text-[36px] md:text-[40px] font-urbanist font-bold leading-[1] ${
                    stat.isHighlighted ? 'text-white' : 'text-[#1a1a1a]'
                  }`}>★</span>
                ) : (
                  <p data-component-id="src/components/sections/StatsSection.jsx:57:18" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="57" data-component-end-line="61" data-component-file="StatsSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D" className={`text-[32px] sm:text-[36px] md:text-[40px] font-urbanist font-bold leading-[1] text-center ${
                    stat.isHighlighted ? 'text-white' : 'text-[#1a1a1a]'
                  } w-auto`}>
                    {stat.unit}
                  </p>
                )}
              </div>
              <p data-component-id="src/components/sections/StatsSection.jsx:64:14" data-component-path="src/components/sections/StatsSection.jsx" data-component-line="64" data-component-end-line="68" data-component-file="StatsSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D" className={`text-[14px] sm:text-[15px] md:text-[16px] font-urbanist font-medium leading-[20px] sm:leading-[22px] md:leading-[24px] text-center ${
                stat.isHighlighted ? 'text-white/90' : 'text-[#6b7280]'
              } w-full max-w-[180px]`}>
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
